<template>
  <v-dialog v-model="open" :max-width="elinkId != null ? 640 : 720" persistent
    :scrollable="elinkId == null" class="gm-dialog">
    <v-card class="rounded-30 overflow-hidden dialog-card">
      <div class="gm-dialog-header d-flex align-center px-8 py-6">
        <div class="text-h5">
          <template v-if="elinkId != null">
            <template v-if="isEdit">
              <span style="color: #2655F1;">编辑</span><span>计量电表</span>
            </template>
            <template v-else>
              <span style="color: #2655F1;">新增</span><span>计量电表</span>
            </template>
          </template>
          <template v-else>
            <template v-if="isEdit">
              <span style="color: #2655F1;">编辑</span><span>电表</span>
            </template>
            <template v-else>
              <span style="color: #2655F1;">新增</span><span>电表</span>
            </template>
          </template>
        </div>
        <v-spacer />
        <v-btn icon="mdi-close" variant="text" color="rgba(46, 46, 46, 0.5)" @click="emit('close')" />
      </div>
      <v-card-text class="pa-8 pt-0">
        <template v-if="elinkId != null">
          <div class="form-grid-3">
            <div class="form-group">
              <label>计量电表名称 <span class="required-star">*</span></label>
              <v-text-field v-model="draft.meterName" placeholder="请输入名称" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>计量电表UUID <span class="required-star">*</span></label>
              <v-text-field v-model="draft.uuid" placeholder="根据能量链序号自动生成UUID" variant="flat" density="compact"
                class="gm-input" hide-details readonly />
            </div>
            <div class="form-group">
              <label>计量电表设备devID <span class="required-star">*</span></label>
              <v-text-field v-model="draft.devId" placeholder="请输入设备devID" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
          </div>
        </template>
        <template v-else>
          <div class="form-grid-2">
            <div class="form-group">
              <label>产品型号 <span class="required-star">*</span></label>
              <v-select v-model="draft.productModel" :items="meterModelOptions" item-title="title"
                item-value="value" :loading="meterModelLoading" placeholder="请选择产品型号" variant="flat" density="compact"
                class="gm-input" hide-details clearable @update:model-value="(v) => emit('model-change', v)" />
            </div>
            <div class="form-group">
              <label>电表名称 <span class="required-star">*</span></label>
              <v-text-field v-model="draft.meterName" placeholder="请输入电表名称" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>厂家名称</label>
              <v-text-field v-model="draft.factoryName" placeholder="请选择产品型号后自动带出" variant="flat"
                density="compact" class="gm-input" hide-details readonly />
            </div>
            <div class="form-group">
              <label>电表类型 <span class="required-star">*</span></label>
              <v-select v-model="draft.meterType" :items="meterTypeOptions" item-title="title" item-value="value"
                placeholder="请选择电表类型" variant="flat" density="compact" class="gm-input" hide-details
                :disabled="isEdit" />
            </div>
            <div class="form-group">
              <label>UUID <span class="required-star">*</span></label>
              <v-text-field v-model="draft.uuid" placeholder="选择电表类型后自动生成UUID" variant="flat" density="compact"
                class="gm-input" hide-details readonly />
            </div>
            <div class="form-group">
              <label>设备devID</label>
              <v-text-field v-model="draft.devId" placeholder="请输入设备devID" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>安装位置 <span class="required-star">*</span></label>
              <v-select v-model="draft.productLocation" :items="productLocationOptions" item-title="title"
                item-value="value" placeholder="请选择安装位置" variant="flat" density="compact" class="gm-input"
                hide-details />
            </div>
            <div class="form-group">
              <label>电表变比 <span class="required-star">*</span></label>
              <v-text-field v-model.number="draft.productRatio" type="number" min="0" max="99999"
                placeholder="请输入电表变比" variant="flat" density="compact" class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>通信接口</label>
              <v-text-field v-model="draft.commInterface" placeholder="请输入通信接口" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>父级电表UUID</label>
              <v-text-field v-model="draft.parentMeterUuid" placeholder="请输入父级电表UUID" variant="flat"
                density="compact" class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>关联设备UUID</label>
              <v-text-field v-model="draft.linkEquipmentUuid" placeholder="请输入关联设备UUID" variant="flat"
                density="compact" class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>测量设备关联ID</label>
              <v-text-field v-model="draft.measuringEquipIdStr" placeholder="请输入逗号分隔的测量设备关联ID" variant="flat"
                density="compact" class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>资产编号</label>
              <v-text-field v-model="draft.assetCode" placeholder="请输入资产编号" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>资产性质</label>
              <v-text-field v-model="draft.assetProperty" placeholder="请输入资产性质" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
            <div class="form-group">
              <label>资产单位</label>
              <v-text-field v-model="draft.assetUnit" placeholder="请输入资产单位" variant="flat" density="compact"
                class="gm-input" hide-details />
            </div>
            <div class="form-group meter-image-group meter-image-group--span-rows">
              <label>电表图片</label>
              <div class="meter-image-upload">
                <el-upload class="meter-image-upload__control" :show-file-list="false" accept="image/*"
                  :before-upload="beforeUpload" :http-request="httpRequest">
                  <div class="meter-photo-slot rounded-lg d-flex align-center justify-center" role="button"
                    tabindex="0">
                    <img v-if="draft.imageUrl" :src="draft.imageUrl" alt="电表图片"
                      class="meter-photo-preview" />
                    <v-icon v-else size="32" color="primary">mdi-plus</v-icon>
                  </div>
                </el-upload>
                <button v-if="draft.imageUrl" type="button" class="meter-photo-slot__remove"
                  @click="emit('clear-image')">
                  <v-icon size="16" color="white">mdi-close</v-icon>
                </button>
              </div>
            </div>
            <div class="form-group grid-full">
              <label>设备描述</label>
              <v-textarea v-model="draft.productDescription" placeholder="请输入设备描述" variant="flat"
                density="compact" class="gm-input" hide-details rows="3" />
            </div>
            <div class="form-group">
              <label>排序号</label>
              <v-text-field v-model.number="draft.sort" type="number" min="0" placeholder="请输入排序号" variant="flat"
                density="compact" class="gm-input" hide-details />
            </div>
          </div>
        </template>
      </v-card-text>
      <v-card-actions class="px-8 pb-8 pt-0 justify-end">
        <v-btn variant="flat" color="#D9D9D9" class="gm-btn-secondary px-10 mr-4" @click="emit('close')">取消</v-btn>
        <v-btn color="#2655F1" variant="flat" class="gm-btn-primary px-10 text-white" :loading="submitting"
          @click="emit('submit')">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup>
import { meterTypeOptions, productLocationOptions } from '../utils/constants'

const open = defineModel({ type: Boolean, default: false })
defineProps({
  draft: { type: Object, required: true },
  isEdit: { type: Boolean, default: false },
  submitting: { type: Boolean, default: false },
  // 非空表示在编辑「eLink 计量电表」（简化模式），null 表示顶层电表（完整表单）
  elinkId: { type: [Number, String], default: null },
  meterModelOptions: { type: Array, default: () => [] },
  meterModelLoading: { type: Boolean, default: false },
  // el-upload 的 before-upload / http-request 需要函数返回值/调用体，用 props 而非 emit
  beforeUpload: { type: Function, default: () => true },
  httpRequest: { type: Function, default: () => {} },
})
const emit = defineEmits(['close', 'submit', 'model-change', 'clear-image'])
</script>

<style scoped lang="scss" src="../styles/step-device.scss"></style>
